define([
	"dojo/_base/declare",
	"./StringTextarea"
], function(declare,StringTextarea) {

	return declare(StringTextarea, {
		canBeLarge: function(/*Context*/ctx, /*Heading*/h) {
			// summary: force value to display on own line in Property view
			return 2;
		}
	});
});